import type { Transition } from "@uirouter/core";

import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { SourceType } from "app/UtilitiesAndConstants/Constants/SourceTypes";

import { isPaidKwSearchAvailable, isPaidSearchPagesAvailable } from "./permissions";

export const onRedirectValidateSelectedPageTab =
    (usePaidKwSearchPermission: boolean, fallbackTab: string = SourceType.TOTAL): transitionHookFn =>
    (transition: Transition) => {
        const toParams = transition.params("to");
        const selectedPageTab = toParams?.selectedPageTab;

        if (!selectedPageTab || selectedPageTab !== SourceType.PAID) {
            return;
        }

        const hasPaidPermission = usePaidKwSearchPermission ? isPaidKwSearchAvailable() : isPaidSearchPagesAvailable();
        if (!hasPaidPermission) {
            return {
                params: {
                    ...toParams,
                    selectedPageTab: fallbackTab,
                },
            };
        }
    };
